(() => {
  const callback = () => {
    const selectors = {
      popup: '.popup',
      trigger: '.popup__trigger',
      closeButton: '[data-action="close-popup"]',
    };

    const triggers = document.querySelectorAll(`${selectors.trigger}:not(.initialized)`);

    triggers.forEach((trigger) => {
      const popup = document.querySelector(`${selectors.popup}[data-popup-id='${trigger?.dataset?.triggerFor}']`);
      if (!popup) return;

      trigger.addEventListener('click', () => popup.showModal());
      trigger.classList.add('initialized');

      popup.addEventListener('click', (event) => {
        const isPopupBackdrop = event.target.matches(selectors.popup);
        const isCloseButton = event.target.closest(selectors.closeButton);

        if (isPopupBackdrop || isCloseButton) popup.close();
      });
    });
  };

  document.addEventListener('popup:init', callback);
  window.addEventListener('DOMContentLoaded', callback);
})();
